import { AnsweringClient } from "../../../../clients/answeringClient";

export interface IAssignment {
  applicationId: number;
  title: string;
  dueDate: Date;
  instrumentTitle: string;
}

export interface AddInstrumentModalControllerDelegate {
  didGetAssignments: (assignments: IAssignment[]) => void;
  didAddAssignments: () => void;
  applicationShouldLogout: () => void;
  insufficientLicensesError: () => void;
  genericError: () => void;
}

export class AddInstrumentModalController {
  constructor(
    private delegate: AddInstrumentModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async getManagedAssignments(accessToken: string) {
    try {
      const response = await this.answeringClient.getManagedAssignments(
        accessToken
      );
      const data = response.data.data as IAssignment[];
      const now = new Date();
      const filteredData = data.filter((assignment) => {
        return new Date(assignment.dueDate) > now;
      });
      this.delegate.didGetAssignments(filteredData);
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        this.getManagedAssignments(newTokens.accessToken);
        return;
      }
      this.delegate.genericError();
    }
  }

  public async addAssignmentsToUser(
    accessToken: string,
    userUid: string,
    assignmentIds: number[]
  ) {
    try {
      await this.answeringClient.addAssignmentsToUser(
        accessToken,
        userUid,
        assignmentIds
      );
      this.delegate.didAddAssignments();
    } catch (error: any) {
      if (error?.response?.status === 402) {
        this.delegate.insufficientLicensesError();
        return;
      }
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        this.addAssignmentsToUser(
          newTokens.accessToken,
          userUid,
          assignmentIds
        );
        return;
      }
      this.delegate.genericError();
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
